// extracted by mini-css-extract-plugin
module.exports = {"glitch":"SectionCard_glitch__LPecn"};